<template>
  <div>
    <div style="width:100%;height:100;" class="wx-load-c" v-show="wxShow">
      <p style="text-align: right;">
        <Icon type="ios-close" style="margin: 20px;font-size: 30px;cursor: pointer;" @click="wxClose"/>
      </p>
      <div style="margin-top: 160px;" id="login_container2"></div>
    </div>
    <Header class="black"></Header>
    <div class="container ac">
      <h1>账号设置</h1>
      <div class="ab">
        <h2>用户资料</h2>
        <form
          id="fileupload"
          action="jf/platform/sdContent/save"
          method="POST"
          role="form"
          class="form-horizontal smart-wizard"
          style="padding-left: 340px;position: relative;"
        >
          <div class="form-group"></div>
          <div class="form-group">
            <div class="col-sm-2 col-sm-offset-2">
              <span style="font-size: 12px;color: #424753;">支持上传JPG\PNG或GIF格式图片文件，文件大小不能超过250KB</span>
              <br/>
              <span style="font-size: 12px;color: #424753;">建议上传尺寸 200 X 200 像素</span>
            </div>
          </div>
          <div class="col-sm-2">
            <button
              type="button"
              class="btn btn-danger delete-row btn-empty"
              id="selectVideoPhoto"
              style="color: #000000;background: #FFFFFF;border: 1px solid #D8D8D8;border-radius: 2px;margin-top: 20px;"
            >上传头像</button>
          </div>
          <div class="col-sm-7">
            <input type="text" name="content.video_photo" val class style="display: none;">
          </div>
          <div class="form-group" style="position: absolute;left:220px;top:0;">
            <!--<label class="col-sm-2 control-label">头像预览</label>-->
            <div class="col-sm-2" v-if="Object.keys(state).length > 0">
              <img
                :src="state.data.faceUrl"
                alt
                style="width: 100px;height: 100px;border-radius: 50%;"
              >
              <!--<img :src="uesrFace" alt="" style="width: 100px;height: 100px;border-radius: 50%;">-->
            </div>
          </div>
        </form>
        <p style="margin-top: 30px">
          <!--<input type="text" placeholder="设置您的用户昵称" v-model="nickName">-->
          <input
            v-if="Object.keys(state).length > 0"
            type="text"
            :placeholder="state.data.nickName"
            v-model="nickName"
          >
          <button class="save-btn" @click="changeName()">保存</button>
        </p>
      </div>
      <div class="ab" v-if="Object.keys(state).length>0">
        <h2>第三方登录</h2>
        <p class="sf">
          <img src="../../assets/images/wechat-hover.png" alt>
          <span style="margin: 0 20px;display: inline-block;margin-left: 74px;" v-if="state.data.unionId">已绑定</span>
          <span style="margin: 0 20px;display: inline-block;margin-left: 74px;" v-if="!state.data.unionId">未绑定</span>
          <span style="color: #3E87FF;cursor: pointer;margin-left: 149px;" v-if="state.data.unionId" @click="unBindWeixin">去解绑</span>
          <span style="color: #3E87FF;cursor: pointer;margin-left: 149px;" v-if="!state.data.unionId" @click="goBindWx">去绑定</span>
        </p>
        <p class="sf" v-if="false">
          <img src="../../assets/images/qq-hover.png" alt>
          <span style="width: 100px;margin: 0 20px;display: inline-block">未绑定</span>
          <span style="color: #3E87FF;">去绑定</span>
        </p>
        <p class="sf" v-if="false">
          <img src="../../assets/images/weibo-hover.png" alt>
          <span style="width: 100px;margin: 0 20px;display: inline-block">未绑定</span>
          <span style="color: #3E87FF;">去绑定</span>
        </p>
      </div>
      <div class="ab" style="border: none;">
        <h2>账号安全</h2>
        <p class="sf">
          <span style="width: 60px;margin-right: 20px;display: inline-block">手机号</span>
          <span
            style="width: 100px;margin: 0 20px;display: inline-block"
            v-if="Object.keys(state).length > 0"
          >{{state.data.account|phoneCard}}</span>
          <span style="color: #3E87FF;cursor: pointer;margin-left: 93px;" @click="modal1 = true">修改</span>
        </p>
        <p class="sf">
          <span style="width: 60px;margin-right: 20px;display: inline-block">账号密码</span>
          <span style="width: 100px;margin: 0 20px;display: inline-block">******</span>
          <span
            style="color: #3E87FF;cursor: pointer;margin-left: 93px;"
            @click="modify.setPsd = true"
          >修改密码</span>
        </p>
        <p class="sf">
          <span style="width: 60px;margin-right: 20px;display: inline-block">邮箱</span>
          <span
            style="width: 100px;margin: 0 20px;display: inline-block"
            v-if="Object.keys(state).length > 0"
          >{{state.data.email || '暂未绑定'}}</span>
          <span style="color: #3E87FF;cursor: pointer;margin-left: 93px;" @click="openEmail()">绑定邮箱</span>
        </p>
      </div>
    </div>
    <Modal v-if="Object.keys(state).length > 0" v-model="modal1" title="修改手机号" width="400" @on-ok="ok" @on-cancel="cancel" footer-hide >
      <div v-if="tep">
        <h2
          v-if="Object.keys(state).length > 0"
          style="font-size: 14px;color: #424753;"
        >原手机号：{{state?state.data.account:0}}</h2>
        <p style="margin-top: 20px;">
          <input
            type="text"
            placeholder="输入验证码"
            style="width: 230px;vertical-align: bottom;"
            v-model="code"
          >
          <button class="get-btn" @click="getMobileSms()" v-show="show">{{yzm}}</button>
          <button class="get-btn" v-show="!show">{{count}}s</button>
        </p>
        <button
          class="btn btn-default"
          style="width: 150px;height: 40px;text-align: center;margin-left: calc(50% - 75px);margin-top:40px;margin-bottom: 40px;"
          @click="changeSms()"
        >下一步</button>
      </div>
      <div v-if="!tep">
        <p>
          <input type="text" placeholder="新手机号不能与旧手机号相同" v-on:blur="newOld()" v-model="phone">
          <!--<span style="display: block;color:#e4393c;padding-top: 10px;" v-if="fs">*新手机号不能与旧手机号相同</span>-->
          <span style="display: block;color:#e4393c;padding-top: 10px;" v-if="fs">{{phoneMsg}}</span>
        </p>
        <p style="margin-top: 20px;">
          <input type="text" placeholder="输入验证码" style="width: 230px;" v-model="code2">
          <button
            style="width: 86px;"
            class="get-btn"
            @click="getMobileSms('1987')"
            v-show="show2"
          >{{yzm2}}</button>
          <button style="width: 86px;" class="get-btn" v-show="!show2">{{count2}}s</button>
        </p>
        <button
          class="btn btn-default"
          style="width: 150px;height: 40px;text-align: center;margin-left: calc(50% - 75px);margin-top:40px;margin-bottom: 40px;"
          @click="changePhone()"
        >绑定</button>
      </div>
    </Modal>
    <Modal
      v-if="Object.keys(state).length>0"
      v-model="modify.setPsd"
      title="设置安全密码"
      width="600"
      @on-ok="ok"
      @on-cancel="cancel"
      footer-hide
    >
      <div style="width: 600px;height: 460px;margin-left: -20px;">
        <p class="center-p">
          <label>手机号</label>
          <span>{{state.data.account|phoneCard}}</span>
        </p>
        <p class="center-p">
          <label style="display: block;margin-bottom: 8px;">手机验证码</label>
          <input
            type="text"
            placeholder="请输入验证码"
            class="yzm-ipt"
            style="width: 269px;height: 40px;line-height: 40px;vertical-align: middle;"
            v-model="modify.code"
          >
          <span
            class="get-yzm"
            @click="getYzm()"
            v-show="modify.show"
            style="vertical-align: middle;width: 111px;height: 40px;line-height: 40px;border: 1px solid #ddd;margin-left: 20px;float: right;text-align: center;display: block;"
          >获取验证码</span>
          <span
            class="get-yzm"
            v-show="!modify.show"
            style="vertical-align: middle;width: 111px;height: 40px;line-height: 40px;border: 1px solid #ddd;margin-left: 20px;float: right;text-align: center;"
          >{{modify.count}}s</span>
        </p>
        <p class="center-p">
          <label style="display: block;margin-bottom: 8px;">新密码</label>
          <input
            type="password"
            placeholder="请输入新密码"
            style="width: 100%;height: 40px;line-height: 40px;"
            v-model="modify.password"
          >
        </p>
        <p class="center-p">
          <label style="display: block;margin-bottom: 8px;">重复新密码</label>
          <input
            type="password"
            placeholder="请再次输入密码"
            style="width: 100%;height: 40px;line-height: 40px;"
            v-model="modify.confirmPassword"
          >
        </p>
        <p class="center-p" style="text-align: center;margin-top: 40px;">
          <button class="btn btn-default" style="width: 150px;height: 40px;" @click="savePsd()">确认提交</button>
        </p>
      </div>
    </Modal>
    <Modal
      v-if="Object.keys(state).length>0"
      v-model="email.show"
      title="绑定邮箱"
      width="400"
      @on-ok="ok"
      @on-cancel="cancel"
      footer-hide
    >
      <div style="width: 400px;height: 160px;margin-left: -16px;margin-top: 20px">
        <p class="center-p" style="width: 300px;margin: 0 auto">
          <input
            type="text"
            placeholder="请输入邮箱"
            style="width: 100%;height: 40px;line-height: 40px;"
            v-model="email.email"
          >
        </p>
        <p class="center-p" style="text-align: center;margin-top: 20px;">
          <button
            class="btn btn-default"
            style="width: 150px;height: 40px;"
            @click="postEmail()"
          >发送验证邮箱</button>
        </p>
      </div>
    </Modal>
    <Footer></Footer>
  </div>
</template>

<script>
import "@/assets/js/common";
import $ from "jquery";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { codeApi, accountApi, apiReg } from "../../fetch/api";
import u from "../../util/util";

export default {
  name: "account",
  components: {
    Footer,
    Header
  },
  data() {
    return {
      yzm: "获取验证码",
      count: "",
      yzm2: "获取验证码",
      count2: "",
      timer: "",
      timer2: "",
      modal1: false,
      modal2: false,
      state: {},
      code: "",
      code2: "",
      tep: true,
      phone: "",
      fs: false,
      nickName: "",
      file: "",
      // justtoken:'http://192.168.1.251:8111/qvbian/api/getAliPolicy',
      show: true,
      show2: true,
      pam: {},
      uesrFace: "",
      phoneMsg: "",
      modify: {
        setPsd: false,
        timer: "",
        show: true,
        count: "",
        phone: "",
        code: "",
        password: "",
        confirmPassword: ""
      },
      email: {
        show: false,
        email: ""
      },
      wxShow: false
    };
  },
  methods: {
    unBindWeixin() {
      confirm("确定解绑？解绑微信账号后将无法继续使用它登录该账号", re => {
        if (re) {
          apiReg.apiWeixinOpenUnbind().then(data => {
            if(data.status == 1){
              msgSuccess('解绑成功')
              location.reload();
            }
          });
        }
      });
    },
    wxClose(){
      this.wxShow = false
      location.reload();
    },
    goBindWx(){
      this.wxShow = true;
    },
    openEmail() {
      this.email.email = "";
      this.email.show = true;
    },
    postEmail() {
      if (!this.email.email) {
        msgError("请输入邮件！");
      } else {
        var regs = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        var r = this.email.email.match(regs);
        if (r == null) {
          msgError("请输入正确邮箱格式！");
          return;
        }
        apiReg
          .apiAccountSendBindMail({ email: this.email.email,from:1})
          .then(data => {
            console.log(data);
            if (data.status === 1) {
              msgSuccess("请注意查收邮件");
              this.email.show = false;
            } else {
              msgError(data.message);
            }
          });
      }
    },
    getYzm() {
      if (!this.state.data.account) {
        msgError("请输入手机号！");
      } else {
        let pam = {
          phone: this.state.data.account
        };
        codeApi.apiGetSmsCode_2(pam).then(data => {
          if (data.status == 1) {
            msgSuccess("请注意查收验证码！");
            const TIME_COUNT2 = 59;
            if (!this.modify.timer) {
              this.modify.count = TIME_COUNT2;
              this.modify.show = false;
              this.modify.timer = setInterval(() => {
                if (this.modify.count > 0 && this.modify.count <= TIME_COUNT2) {
                  this.modify.count--;
                } else {
                  this.modify.show = true;
                  clearInterval(this.modify.timer);
                  this.modify.timer = null;
                }
              }, 1000);
            }
          } else {
            msgError(data.message);
          }
        });
      }
    },
    savePsd() {
      let pam = {
        phone: this.state.data.account,
        code: this.modify.code,
        password: this.modify.password,
        confirmPassword: this.modify.confirmPassword
      };
      apiReg.apiResetPassword(pam).then(data => {
        if (data.status === 1) {
          msgSuccess("提交成功！");
          this.modify.code = "";
          this.modify.password = "";
          this.modify.confirmPassword = "";
          this.modify.count = 0;
          this.modify.setPsd = false;
          window.location.reload();
        } else {
          msgError(data.message);
        }
      });
    },
    newOldPsd() {},
    beforeHandle() {
      this.getToken();
    },
    onProgress() {},
    handleSuccess(res, file) {
      console.log(res);
      console.log(file);
    },
    getDetail() {
      accountApi.apiAccountGetDetail().then(data => {
        console.log(data);
        this.state = data;
        this.userInfos = data.data.faceUrl;
      });
    },
    ok() {},
    cancel() {},
    getMobileSms(tem) {
      if (!tem) {
        if (!this.state.data.account) {
          msgError("请填写手机号！");
          return;
        }
        let pam = {
          phone: this.state.data.account
        };
        codeApi.apiGetSmsCode_4(pam).then(data => {
          if (data.status == 1) {
            const TIME_COUNT = 59;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        });
      } else {
        if (!this.phone) {
          msgError("请填写手机号！");
          return;
        }
        let pam = {
          phone: this.phone
        };
        codeApi.apiGetSmsCode_4(pam).then(data => {
          if (data.status == 1) {
            const TIME_COUNT = 59;
            if (!this.timer2) {
              this.count2 = TIME_COUNT;
              this.show2 = false;
              this.timer2 = setInterval(() => {
                if (this.count2 > 0 && this.count2 <= TIME_COUNT) {
                  this.count2--;
                } else {
                  this.show2 = true;
                  clearInterval(this.timer2);
                  this.timer2 = null;
                }
              }, 1000);
            }
          }
        });
      }
    },
    changeSms() {
      let pam = {
        phone: this.state.data.account,
        code: this.code
      };
      codeApi.apiAccountVerifyFormalMobileSms4(pam).then(data => {
        console.log(data);
        if (data.status === 1) {
          this.tep = false;
          this.show = true;
        } else {
          msgError(data.message);
        }
      });
    },
    newOld() {
      let pam = {
        phone: this.phone
      };
      accountApi.apiAccountVerifyPhoneValid(pam).then(data => {
        console.log(data);
        if (data.status !== 1) {
          this.fs = true;
          this.phoneMsg = data.message;
        } else {
          this.fs = false;
        }
      });
    },
    changePhone() {
      let pam = {
        phone: this.phone,
        code: this.code2
      };
      if (this.fs == false) {
        accountApi.apiAccountChangeMobile(pam).then(data => {
          console.log(data);
          if (data.status === 1) {
            msgSuccess(data.message || "成功！");
            this.getDetail();
            location.reload();
          } else {
            this.phoneMsg = data.message;
            msgError(data.message);
          }
        });
      } else {
        this.fs = true;
      }
    },
    changeName() {
      let pam = {
        // "faceUrl": $("[name='content.video_photo']").val(),
        faceUrl: this.state.data.faceUrl,
        nickName: this.nickName
      };
      var regs = /^[\w\u4e00-\u9fa5]+$/gi;
      console.log(pam.nickName.match(regs));
      if (pam.nickName === "" || pam.nickName.match(regs) == null) {
        alert("昵称不能为空且不能有特殊字符！");
      } else {
        accountApi.apiAccountEditAccount(pam).then(data => {
          console.log(data);
          if (data.status === 1) {
            location.reload();
          }
        });
      }
    },
    changeFaceUrl(url) {
      let pam = {
        faceUrl: url,
        nickName: this.state.data.nickName
      };
      accountApi.apiAccountEditAccount(pam).then(data => {
        console.log(data);
        if (data.status === 1) {
          location.reload();
        }
      });
    },
    faceUpLoad() {
      var videoPhotoOption = {};
      videoPhotoOption.uploadParentPath = "sd/photo"; //设置保存的文件夹名称，格式 dir1/dir2
      videoPhotoOption.browse_button = "selectVideoPhoto"; //上传文件按钮的id
      videoPhotoOption.callback = () => {
        $("[name='content.video_photo']").val(videoPhotoOption.fileUrl);
        $("#uploadPreview_videoPhoto").css(
          "background-image",
          "url(" + videoPhotoOption.fileUrl + ")"
        );
        this.state.data.faceUrl = videoPhotoOption.fileUrl;
        this.changeFaceUrl(videoPhotoOption.fileUrl);
      }; //上传成功回调方法
      videoPhotoOption.fileType = "jpg,jpeg,png"; //文件类型
      videoPhotoOption.maxFileSize = "100mb"; //文件最大限制
      videoPhotoOption.bucketName = "qvbian-web"; //空间名
      videoPhotoOption.endpoint = "oss-cn-shanghai.aliyuncs.com";
      videoPhotoOption.domainName =
        "https://qvbian-web.oss-cn-shanghai.aliyuncs.com/"; //空间绑定的域名
      $(document).ready(function() {
        UploadDemo.uploader(videoPhotoOption);
      });
    }
  },
  mounted() {
    if (
      u.GetQueryString("accountId") &&
      u.GetQueryString("code") &&
      u.GetQueryString("mail")
    ) {
      let pam = {
        accountId: u.GetQueryString("accountId"),
        code: u.GetQueryString("code"),
        mail: u.GetQueryString("mail")
      };
      apiReg.apiVerifyMail(pam).then(data => {
        if (data.status === 1) {
          msgSuccess("绑定成功,请前往邮箱完成验证！");
          if(u.GetQueryString("from") == 2){
            location.href = "projectPartyA.html?id="+u.GetQueryString("ciId");
          } else if(u.GetQueryString("from") == 3){
            location.href = "projectPartyB.html?id="+u.GetQueryString("ciId");
          }
        } else {
          msgError(data.message);
        }
      });
    }
    this.getDetail();
    this.faceUpLoad();
    var obj = new WxLogin({
      id:"login_container2",
      appid: "wx0f66844ed18e08da",
      scope: "snsapi_login",
      style: "white",
      redirect_uri: "http://www.qvbian.com/qvbian/api/wxOpenRedirect"
    });
  }
};
</script>

<style scoped>
.md-psd p {
  text-align: center;
  width: 360px;
  height: 40px;
  line-height: 40px;
  margin-bottom: 30px;
}
img {
  display: inline-block;
  width: 25px;
  height: 25px;
}
input:focus {
  border: 1px solid #3e87ff;
}
.ac {
  background: #fff;
  padding: 40px;
  min-height: 734px;
  margin: 90px auto 120px;
}
.ac * {
  font-family: PingFangSC-Semibold;
}
.ac h1 {
  font-size: 20px;
  color: #424753;
  margin-bottom: 25px;
}
.ac p {
  padding-left: 340px;
}
.save-btn {
  background: #3e87ff;
  border-radius: 2px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  border: none;
  color: #fff;
  cursor: pointer;
}
.ab {
  padding: 15px 10px 30px;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 20px;
}
.ab h2 {
  font-size: 14px;
  color: #424753;
}
.ab input {
  width: 244px;
  height: 40px;
  line-height: 40px;
  margin-right: 75px;
}
.ab .sf {
  padding-top: 20px;
}
.get-btn {
  border-radius: 2px;
  width: 120px;
  height: 40px;
  line-height: 40px;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
  color: #424753;
  border: 1px solid #d8d8d8;
}
.not-get {
  border: 1px solid #ff5555 !important;
}
.center-p {
  width: 400px;
  margin: 30px auto 0px;
  font-size: 16px;
  color: #424753;
}
.center-p label {
  font-size: 16px;
  color: #424753;
}
.center-p span {
  margin-left: 30px;
}
.wx-load-c{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  z-index: 999999;
  text-align: center;
  color: #fff;
}
.wx-load-c *{
  color: #fff !important;
}
.wx-load-c #login_container{
  position: absolute;
  transform: translateX(-50%) translateY(-50%);
  top: 50%;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// account.vue?4f351e3d